import { NotificationItemProps } from '../types';
import { setNotificationResponse } from './actions';

// eslint-disable-next-line import/prefer-default-export
export const fetchNotificationData =
  (items: NotificationItemProps[], filterFn: (item: NotificationItemProps) => boolean = () => true) =>
  async (dispatch: any) => {
    const loaders = items
      .filter(item => item.loadData && filterFn(item))
      .map(async item => {
        const response = await item.loadData!();
        return { type: item.type, response };
      });

    const results = await Promise.all(loaders);

    results.forEach(result => {
      if (result) {
        dispatch(setNotificationResponse({ type: result.type, response: result.response }));
      }
    });
  };
